import React from "react";
import StoreContext from './../../../Store/Context';
import { NavLink as RRNavLink } from "react-router-dom";
import { NavItem, Navbar, Nav, NavLink, Row, Col, Container } from "reactstrap";
import { LOGO_SCHOOL } from "../../Constants/SrcImages";
import "../../../www/css/style.css";
interface IAdminState{
  children:any;
}
interface IAdminProps {
  children:any;
}
class LayoutDireccion extends React.Component<IAdminProps, IAdminState>{
  static contextType = StoreContext
  constructor(props: IAdminProps) {
    super(props);
    this.state = {
      children:props.children
    };
  }

  updateTokens = () => {
    const test = this.context
    test.quitToken()
  };

  render() {
    return (
      <React.Fragment>
        <Container className="themed-container" fluid={true}>
          <Row>
            <Col sm={2}>
              <Row>
                <Navbar>
                  <Nav tabs>
                    <NavItem className="text-center w-100">
                        <img className="logo-contabilidad" src={LOGO_SCHOOL} alt="" />
                    </NavItem>  
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/direccion/registration" activeClassName="active">
                        Matricula
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/direccion/boletin" activeClassName="active">
                      Boletines
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/direccion/hour" activeClassName="active">
                        Horarios
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/direccion/retired" activeClassName="active">
                        Retirados
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/direccion/teachers" activeClassName="active">
                        Perfil de profesores
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink  tag={RRNavLink} to="/direccion/activation" activeClassName="active">
                      Activaciones y desactivaciones
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100"  onClick={()=> this.updateTokens()} >
                      <NavLink>
                        Salir
                      </NavLink>
                    </NavItem>
                  </Nav>
                </Navbar>
              </Row>
            </Col>
            <Col sm={10}>{this.props.children}</Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default LayoutDireccion;